var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrowToTopLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Up_Right",
    "data-name": "Up Right",
    d: "M32.772,18.085V28.859a1.313,1.313,0,1,1-2.627,0v-7.6L19.014,32.388a1.313,1.313,0,1,1-1.857-1.858L28.289,19.4h-7.6a1.313,1.313,0,0,1,0-2.627H31.459a1.319,1.319,0,0,1,.257.026c.04.008.078.023.117.035a.775.775,0,0,1,.261.11c.031.017.063.031.093.051a1.319,1.319,0,0,1,.365.365c.02.03.034.064.052.1a.775.775,0,0,1,.109.26c.011.038.026.075.034.115a1.319,1.319,0,0,1,.026.257Z",
    transform: "translate(-16.772 -16.772)",
    fill: "#65aad6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowToTopLeft);
export default __webpack_public_path__ + "static/media/icon-arrow-to-top-left.935d5dd2f4ff5b9300dbbb38b3cbc136.svg";
export { ForwardRef as ReactComponent };